



































import { Component, Vue, Watch } from 'vue-property-decorator';
import { padHeadPanel2 } from "@/components";
import cashierOperate from "./components/cashierOperate.vue";
import changeOrder from "./components/changeOrder.vue";
import returnOrder from "./components/returnOrder.vue";
import onlineOrder from "./components/onlineOrder.vue";
import { TbOrderPad, TbShop } from '@/http';
@Component({
    components: {
        padHeadPanel2,cashierOperate,changeOrder,returnOrder,onlineOrder
    },
})
export default class cashier extends Vue {

    active='sy';

    needCharge = true;

    userInfo = {};
    /**是否开通网店 */
    isOnline=localStorage.getItem('isOnline')?JSON.parse(localStorage.getItem('isOnline')):false;
    /**网店订单数 */
    onlineOrderNum=0;
   
    public $refs: {
    };
    created() {
        this.userInfo = JSON.parse(localStorage.getItem("padUserinfo"));
    }
    beforeDestroy() {
        localStorage.removeItem('orderRemark');
        localStorage.removeItem('mulChangePricegSet');   
    }

    async mounted() {
        await this.getOnlineAuth();
        let allotactive = localStorage.getItem("allotactive")
        ? Number(localStorage.getItem("allotactive"))
        : 0;
        this.active = allotactive==0?'sy':allotactive==1?'hh':allotactive==3?'wddd':'th';  
        localStorage.removeItem('allotactive'); 
    }

    tabChange(name,title){
        this.needCharge = this.active=='sy'?true:false;
        localStorage.removeItem('orderRemark');
        localStorage.removeItem('mulChangePricegSet');
    }

    goBackHome(){
        if(this.active=='sy'){
            this.$refs['cashierOperate'].goBackHome();
        }else{
            this.$router.go(-1)
        }
        localStorage.removeItem("gwByCoupon");
        localStorage.removeItem("receivablesByCoupon");
    }

    /**判断权限 */
    hasAuth(auth) {
        let val = false;
        let btnPermissionsStr = this.userInfo['authorityJson'].split(',');
        if (btnPermissionsStr == undefined || btnPermissionsStr == null) {
        val = false;
        }
        if (btnPermissionsStr.some(v=>v==auth)) {
        val = true;
        }
        return val;
    }
    /**判断是否开通网店 */
    async getOnlineAuth(){
        let res = await TbShop.GetOnlineIsOpen();
        if(res===true){
            let res2 = await TbOrderPad.GetOnlineOrderListNum({
                shopId:this.userInfo['shopId'],
                isNotPickUpGoods:true,
                isPartPickUpGoods:true,
                orderStatus:2
            })
            this.onlineOrderNum = res2.totalCount;
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/cashier/cashier.vue